import { keyGenerator } from '@/utils/keyGenerator';
import { Pressable, SxProp } from 'dripsy';
import { TextCaption } from '../../typography';

interface FilterButtonProps {
  isSelected: boolean;
  label: string;
  value: string;
  sx?: SxProp;
  onPress: () => void;
}

export const FilterButton: React.FC<FilterButtonProps> = ({ isSelected, label, value, sx, onPress }) => {
  return (
    <Pressable
      key={keyGenerator('filter-category-options')}
      sx={{
        ...styles.container,
        borderColor: isSelected ? '$filterSelected' : '$borderPrimary',
        backgroundColor: isSelected ? '$filterSelected' : 'transparent',
        ...sx
      }}
      onPress={onPress}>
      <TextCaption>{label}</TextCaption>
    </Pressable>
  );
};

enum StyleName {
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    height: '$8',
    paddingX: '$5',
    borderWidth: 1,
    borderRadius: 100,
    alignItems: 'center',
    justifyContent: 'center'
  }
};
